import { useEffect, useState } from "react";
import { MItem } from "../Menu";
import { Status } from "../day/dayView";
import Spinner from "../../../components/Spinner/Spinner";
import ItemPersonDTO, { ITrainerProfilePayload } from "../../DTO/ItemPersonDTO";
import mainservice from "../../../services/MainService";
import { EventTag, TrainerTypes } from "./Person";
import { parseStringFromServer } from "../../../services/TextConverter";
import EventList from "../Event/EventList";
import { CheckSquare, Copy, Download, Square, Trash } from "react-feather";
import CustomerList from "../Customer/CustomerList";
import { PersonKind } from "./PersonKind";
import PlaningToolRoot, { State } from "../PlaningToolRoot";
import { RightDrawerContent } from "../RightDrawer";
import BroadcastRightButton from "../../elements/BroadcastRightButton";
import { PersonBubble } from "./PersonBubble";
import Debounce from "../../../services/Debounce";
import { PublishKind } from "../../models/publishKinds";
import { MultiRowEditFieldsPrinter } from "../../editFields/EditFieldsPrinter";
import InputB from "../../../components/InputB/InputB";
import LogView from "../Generic/LogView";
import { LexwareButton } from "../Lexware/LexwareButton";
import { Box, Tabs, Tab, Button } from "@mui/material";
import ColorPickerDropDown from "../../../components/ColorPickerDropDown/ColorPickerDropDown";
import LanguageIcon from '@mui/icons-material/Language';
import MailIcon from '@mui/icons-material/Mail';
import LogChat from "../LogChat/LogChat";
import LogChatDetail from "../LogChat/LogChatDetail";
import { downloadTrainerProfileCsv } from "../../DTO/TrainerProfileCsv";

enum LeftTab {
  basic,
  personal,
  invoices,
  misc,
  trainerProfile,
  comunication,
  logs,
}

const LeftTabs = [
  {
    id: LeftTab.basic,
    name: 'Basisdaten',
  },
  {
    id: LeftTab.personal,
    name: 'Persönlich',
  },
  {
    id: LeftTab.comunication,
    name: 'Kommunikation'
  },
  {
    id: LeftTab.invoices,
    name: 'Faktura',
  },
  {
    id: LeftTab.misc,
    name: 'Sonstiges',
  },
  {
    id: LeftTab.trainerProfile,
    name: 'Trainerprofil',
    onlyForTrainer: true
  },
  
  {
    id: LeftTab.logs,
    name: 'Sys'
  },
]

export default function PersonEdit(props: {

}) {
  const id = mainservice.nav.getVal('id') as number
  const page = mainservice.nav.getVal('page') || LeftTab.basic
  const [currentLeftTab, setCurrentLeftTab] = useState(page)
  const [copyToClipBoardState, setCopyToClipBoardState] = useState(0)
  const [status, setStatus] = useState(Status.loading)
  const [RerenderEvents, setRerenderEvents] = useState(0)
  const [rerenderBasic, setRerenderBasic] = useState(0)
  const [EditId, setEditId] = useState(-1)
  const [RerenderCustomers, setRerenderCustomers] = useState(0)
  const [Item, setItem] = useState(new ItemPersonDTO({
    id: id || -1
  }))
  const [UserMsg, setUserMsg] = useState('')
  const broadCastBackKeyEventAdd = `PersonEventAddFor-${Item.id}`
  const broadCastBackKeyCustomerAdd = `PersonCustomerAddFor-${Item.id}`
  const broadCastBackKeyCustomerLocationAdd = `PersonCustomerLocationAddFor-${Item.id}`
  const [chatDetailId, setChatDetailId] = useState<number>(-1)
  const [trainerProfile, setTrainerProfile] = useState<ITrainerProfilePayload | null>(null)
  const [trainerProfileStatus, setTrainerProfileStatus] = useState(Status.loading)
  mainservice.registerToBroadcast(`PersonEdit-${Item.id}`,
    async (key: string, _value: any) => {
      if (key === broadCastBackKeyEventAdd) {
        setStatus(Status.loading)
        await Item.addEvent(_value.id as number)
        setStatus(Status.standard)
      }
      if (key === broadCastBackKeyCustomerAdd) {
        setStatus(Status.loading)
        await Item.addCustomer(_value.id as number)
        setStatus(Status.standard)
      }
      if (key === broadCastBackKeyCustomerLocationAdd) {
        setStatus(Status.loading)
        await Item.addCustomerLocation(_value.id as number)
        setStatus(Status.standard)
      }
    }
  )
  function init () {
    Item.getFromServer().then(() => {
      setStatus(Status.standard)
      console.log('getItem Person', Item)
    }).catch((err) => {
      console.log('err', err)
      setUserMsg(err.description)
    })
  }
  useEffect(() => {
    init()
  }, [])
  useEffect(() => {
    if (currentLeftTab !== LeftTab.trainerProfile || Item.id < 1) {
      return
    }
    let cancelled = false
    setTrainerProfileStatus(Status.loading)
    Item.getTrainerProfile().then((data) => {
      if (cancelled) { return }
      setTrainerProfile(data)
      setTrainerProfileStatus(Status.standard)
    }).catch((err) => {
      if (cancelled) { return }
      console.log('trainerProfile err', err)
      setTrainerProfile(null)
      setTrainerProfileStatus(Status.standard)
      setUserMsg(typeof err === 'string' ? err : (err?.description || 'Trainerprofil konnte nicht geladen werden'))
    })
    return () => { cancelled = true }
  }, [currentLeftTab, Item.id, RerenderEvents])
  function WarnMsg() {
    return <>
      {
      UserMsg &&
      <div
        className={`w3-border w3-border-yellow w3-padding`}
      >
        {UserMsg}
        <button
          onClick={() => {
            setUserMsg('')
          }}
          className={`w3-button w3-grey`}
        >OK</button>
      </div>
    }
    </>
  }

  const leftTabs = LeftTabs.filter(lt => !lt.onlyForTrainer || Item.trainer > -1)

  return <PlaningToolRoot
    standalone={true}
    menuItem={MItem.persons}
    topMenu={
      <Box sx={{ borderBottom: 0, borderColor: 'divider' }}>
        <Tabs value={leftTabs.findIndex(lt => lt.id === currentLeftTab)} onChange={(event, newValue) => {
          const lt = leftTabs[newValue]
          setCurrentLeftTab(lt.id)
          mainservice.nav.setPage(lt.id)
        }}>
          {
            leftTabs.map((lt, index) => {
              return <Tab
                key={`left-tab-${lt.id}`}
                label={lt.name}
                id={LeftTab[lt.id]}
              />
            })
          }
        </Tabs>
      </Box>
    }
    rightDrawer={<LogChatDetail
      id={chatDetailId}
      onClose={() => setChatDetailId(-1)}
    />}
    startStateRightDrawer={chatDetailId > -1 ? State.open : State.closed}
  >
    <div className='contentHeader flex justify-content-space-between'>
      <h1 className='flex-grow'>Person - {Item.getDisplayName()}</h1>
      <button
        className='contentHeader-button positive-hover'
        onClick={() => {
          navigator.clipboard.writeText(Item.getFirstCustomerAddress())
          setCopyToClipBoardState(copyToClipBoardState + 1)
        }}
      >
        <Copy />
      </button>
      <button
        className={`contentHeader-button danger-hover`}
        onClick={async () => {
          if (!window.confirm(`Person ${Item.name} wirklich löschen?`)) { return } 
          await Item.delete()
          mainservice.navTo([['view', 'spPersons']])
        }}
        title="Person löschen"
      ><Trash /></button>
      <PersonBubble item={Item}/>
    </div>
    <WarnMsg />
    { status === Status.loading &&
      <Spinner />
    }
    { status !== Status.loading &&
    <>
      {
        currentLeftTab === LeftTab.basic &&
        <>
          <div className='w3-row'>
            <div className='w3-col s12 m6'>
              <div className='contentPart w3-row'>

                <MultiRowEditFieldsPrinter
                  key={`MultiRowEditFieldsPrinter-${rerenderBasic}`}
                  fields={Item.getMultiEditFields('personSalutation')}
                  item={Item}
                  rerenderParent={(reloadDataNeeded?: boolean) => {
                    if (reloadDataNeeded) {
                      setStatus(Status.loading)
                      init()
                      return
                    }
                    setRerenderBasic(rerenderBasic + 1)
                  }}
                />
                
                <div className='w3-row w3-row-padding'>
                  <div className='EditField w3-col'>
                    <label className='EditFieldLabel'>Vorname</label>
                    <div className="flex">
                      <InputB
                        className='flex-grow'
                        value={parseStringFromServer(Item.firstname || '')}
                        returnVal={async (rv) => {
                          setEditId(-2)
                          await Item.setFirstname(rv)
                          setEditId(-1)
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className='w3-row w3-row-padding'>
                  <div className='EditField w3-col'>
                    <label className='EditFieldLabel'>Nachname</label>
                    <div className="flex">
                      <InputB
                        className='flex-grow'
                        value={parseStringFromServer(Item.lastname || '')}
                        returnVal={async (rv) => {
                          setEditId(-3)
                          await Item.setLastname(rv)
                          setEditId(-1)
                        }}
                      />
                    </div>
                  </div>
                </div>

                <MultiRowEditFieldsPrinter
                  fields={Item.getMultiEditFields('personPosition')}
                  item={Item}
                />
                
                <div className='w3-row w3-row-padding'>
                  <div className='EditField w3-col w3-row-padding w3-margin-bottom'>
                    <label className='EditFieldLabel'>EMail (Geschäftlich)</label>
                    <InputB
                      className='w100'
                      value={parseStringFromServer(Item.email || '')}
                      returnVal={async (rv) => {
                        setEditId(-4)
                        await Item.setEmail(rv)
                        setEditId(-1)
                      }}
                      contentSuffix={
                        <Button
                          variant='outlined'
                          onClick={() => {
                            window.location.href = `mailto:${Item.email}`;
                          }}
                        >
                          <MailIcon />
                        </Button>
                      }
                    />
                  </div>
                </div>

                <MultiRowEditFieldsPrinter
                  fields={Item.getMultiEditFields('personPhone')}
                  item={Item}
                />

                <div className='w3-row w3-row-padding'>
                  <div className='EditField w3-col'>
                    <label className='EditFieldLabel'>LinkedIn/Internet</label>
                    <div className='flex'>
                      <InputB
                        className='flex-grow'
                        value={Item.getPropV1('data', 'Internet') || ''}
                        returnVal={async (rv) => {
                          setEditId(-4)
                          await Item.addProp('data', 'Internet', rv)
                          setEditId(-1)
                        }}
                        contentSuffix={
                          Item.getPropV1('data', 'Internet') ?
                          <Button
                            variant='outlined'
                            onClick={(e) => {
                              e.preventDefault();
                              window.open(Item.getPropV1('data', 'Internet'), '_blank');
                            }}
                          ><LanguageIcon /></Button>
                          :
                          <Button
                            variant='outlined'
                            disabled
                            title="Keine Profil bekannt"
                          >
                            <LanguageIcon />
                          </Button>
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div className='w3-col s12 m6'>
              <div className='contentPart w3-row'>
                <MultiRowEditFieldsPrinter
                  fields={Item.getMultiEditFields('personNotes')}
                  item={Item}
                />
              </div>
            </div>
          </div>

          <div className='contentPart w3-row'>

            <div className='w3-col s12 m12 l8 w3-margin-top'>
              <CustomerList
                personId={Item.id}
                noSearch={true}
                rerenderTrigger={RerenderCustomers}
                onRemove={async (id) => {
                  await Item.removeCustomer(id)
                  setRerenderCustomers(RerenderCustomers + 1)
                }}
                headline={'Unternehmen'}
                options={[['customerShowAddress', 'yes'], ['customerPrefixAddress', Item.getDisplayName()], ['customerPersonLexware', `${Item.id}`], ['customerMarkStale', 'yes']]}
              />
              <BroadcastRightButton
                contentType={RightDrawerContent.selectCustomer}
                broadCastBackKey={broadCastBackKeyCustomerAdd}
                title={`Einem Unternehmen zuordnen`}
              />
            </div>
          </div>

          <div className='contentPart'>
            <EventList
              personId={Item.id}
              noSearch={true}
              noNew={true}
              rerenderTrigger={RerenderEvents}
              allowRemove={true}
              headline={'Veranstaltungen'}
              publishKind={PublishKind.isSeminar}
              ignoreDate='ignore'
            />
            <BroadcastRightButton
              contentType={RightDrawerContent.selectEvent}
              broadCastBackKey={broadCastBackKeyEventAdd}
              title={`Weitere Veranstaltung zuordnen`}
            />
          </div>


        </>
      }
      {
        currentLeftTab === LeftTab.personal &&
        <>
          <div className='w3-row'>
            <div className='w3-col s12 m6'>
              <div className='contentPart w3-row'>
                <div className='contentHeader'>
                  <h2>
                    Persönliche Informationen
                  </h2>
                </div>
                <MultiRowEditFieldsPrinter
                  fields={Item.getMultiEditFields('personPrivateInfo')}
                  item={Item}
                />
              </div>
            </div>
            <div className='w3-col s12 m6'>
              <div className='contentPart w3-row'>
                <div className='contentHeader flex justify-content-space-between'>
                  <h2 className='flex-grow'>
                    Private Adresse
                  </h2>
                  <button
                    className='contentHeader-button positive-hover'
                    onClick={() => {
                      navigator.clipboard.writeText(Item.getPrintAddress())
                      setCopyToClipBoardState(copyToClipBoardState + 1)
                    }}
                  >
                    <Copy />
                  </button>
                </div>
                <MultiRowEditFieldsPrinter
                  fields={Item.getMultiEditFields('personPrivateAddress')}
                  item={Item}
                />
              </div>
            </div>  
          </div>
        </>
      }
      {
        currentLeftTab === LeftTab.invoices &&
        <>
          <div className='contentPart w3-row'>
            <LexwareButton
              item={Item}
              kind={"private"}
            />
          </div>
        </>
      }
      {
        currentLeftTab === LeftTab.misc &&
        <>
          <div className='contentPart' style={{minHeight: '400px'}}>
            <div className='contentHeader'>
              <h2>
                Sonstiges
              </h2>
            </div>
            <div className='w3-padding'>
              <ColorPickerDropDown
                side="left"
                currentColor={Item.nameToColor()}
                changeColor={(c) => {
                  Debounce(`personColor-${Item.id}`, async () => {
                    Item.addProp('data', 'color', c)
                  }).catch(() => {})
                }}
              />
              <label>Farbe</label>
            </div>
            <div className='w3-padding'>
              <Check
                name="Ist Trainer"
                value={Item.trainer}
                onCheck={async (v) => {
                  await Item.setTrainer(v)
                }}
              />
              <div className='w3-margin-top'>
                <EventTag
                  person={Item}
                  parent={Item}
                  className='w3-margin-left w3-margin-top w3-margin-bottom'
                  key1={'trainerProp'}
                  key2={'StandardRole'}
                  standardValue={'trainer'}
                  types={TrainerTypes}
                />
                <label className='w3-margin-left'>Standard Rolle</label>
              </div>
            </div>
            <MultiRowEditFieldsPrinter
              fields={Item.getMultiEditFields('personMisc')}
              item={Item}
            />
          </div>
        </>
      }
      

      {
        currentLeftTab === LeftTab.trainerProfile &&
        <div className='contentPart'>
          {
            trainerProfileStatus === Status.loading ?
            <Spinner /> :
            <>
              <div className='contentHeader flex justify-content-space-between'>
                <h2 className='flex-grow'>Trainerprofil</h2>
                <button
                  className='contentHeader-button positive-hover'
                  title='CSV Export'
                  disabled={!trainerProfile}
                  onClick={() => {
                    if (!trainerProfile) { return }
                    downloadTrainerProfileCsv(trainerProfile.events, Item.getDisplayName())
                  }}
                >
                  <Download />
                </button>
              </div>
              {
                trainerProfile &&
                <div className='w3-margin-bottom w3-row'>
                  <div className='w3-col s12 m6 l4 w3-padding-small'>Gesamtzahl der Trainings: <b>{trainerProfile.stats.trainingCount}</b></div>
                  <div className='w3-col s12 m6 l4 w3-padding-small'>Gesamtzahl der Teilnehmenden: <b>{trainerProfile.stats.participantSum}</b></div>
                  <div className='w3-col s12 m6 l4 w3-padding-small'>Gesamtzahl der unterschiedlichen Teilnehmer: <b>{trainerProfile.stats.distinctParticipantCount}</b></div>
                  <div className='w3-col s12 m6 l4 w3-padding-small'>Gesamtzahl der unterschiedlichen Länder: <b>{trainerProfile.stats.distinctCountryCount}</b></div>
                  <div className='w3-col s12 m6 l4 w3-padding-small'>Gesamtzahl der Auslandsreisen: <b>{trainerProfile.stats.abroadTripCount}</b></div>
                </div>
              }
            </>
          }
          <EventList
            personId={Item.id}
            noSearch={true}
            noNew={true}
            rerenderTrigger={RerenderEvents}
            allowRemove={true}
            personKind={PersonKind.trainer}
            headline={'Veranstaltungen - als Trainer'}
            publishKind={PublishKind.isSeminar}
            ignoreDate='ignore'
            limit={5000}
          />
        </div>
      }

      {
        currentLeftTab === LeftTab.comunication &&
        <div className='contentPart'>
          <MultiRowEditFieldsPrinter
            fields={Item.getMultiEditFields('PersonComunicationEditFields')}
            item={Item}
          />
          <h2>Log zur Person</h2>
          <LogChat
            personId={Item.id}
            onClickDetail={(id) => setChatDetailId(id)}
            markedId={chatDetailId}
          />
        </div>
      }

      {
        currentLeftTab === LeftTab.logs &&
        <div className='contentPart'>
          <LogView getLogs={async () => await Item.getLogs()} className='w3-margin-top'/>
        </div>
      }

      

      
    </>
    }
  </PlaningToolRoot>
}

function Check(props: {
  name: string,
  value: number,
  onCheck: (i: number) => void,
}) {
  const [value, setValue] = useState(props.value)
  return <div
    onClick={() => {
      const newValue = value === 1 ? 0 : 1
      setValue(newValue)
      props.onCheck(newValue)
    }}
    className={`flex`}
  >
    <div className={`pointer`}>
      {
        (value && value > 0) ?
        <CheckSquare /> : <Square />
      }
    </div>
    <div
      className={`flex-grow`}
    >{props.name}</div>
  </div>
}
